export default __webpack_public_path__ + "static/media/ms1.c8c47ea0.jpg";